export default "__VITE_ASSET__4e284ac7__"